<template>
  <div
    class="tooth"
    v-click-outside="onCloseMenu">
    <tooth-popover-menu v-bind:value="isShowMenu" top>
      <template slot="trigger">
        <div class="tooth__body">
          <svg
            v-if="!isDeleted"
            class="tooth-down-2 tooth__parts"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 72 183">
            <g v-if="isDiagnosisImplant" id="implant">
              <rect width="25.564" height="13.231" x="23.762" y="109.08" fill="#A8BEC5" stroke="#778F9F" rx="1.397" />
              <path fill="#778F9F" stroke="#778F9F" stroke-width=".949" d="M46.96 126.171H26.129l4.836 55.777h11.904l4.093-55.777Z" />
              <rect width="29.845" height="4.309" x="-.474" y=".474" fill="#A8BEC5" stroke="#778F9F" stroke-width=".949" rx="1.146" transform="matrix(1 0 0 -1 22.096 127.12)" />
              <path fill="#A8BEC5" stroke="#778F9F" stroke-linecap="round" stroke-width=".949" d="M23.465 130.829a1.68 1.68 0 0 1 1.939-1.372l23.52 4.032.168.037a1.68 1.68 0 0 1-.736 3.274l-23.52-4.032a1.68 1.68 0 0 1-1.371-1.939Zm2.433 5.266.17.02 22.177 3.696a1.68 1.68 0 0 1-.552 3.314l-22.177-3.695-.167-.037a1.681 1.681 0 0 1 .549-3.298Zm.339 6.326.172.02 21.84 3.696a1.68 1.68 0 0 1-.56 3.313l-21.842-3.696-.167-.037a1.68 1.68 0 0 1 .557-3.296Zm-.758 7.729a1.68 1.68 0 0 1 1.929-1.386l20.496 3.359a1.68 1.68 0 1 1-.544 3.316l-20.495-3.36a1.68 1.68 0 0 1-1.386-1.929Zm2.141 4.924.171.024 19.152 3.696a1.68 1.68 0 0 1-.636 3.299l-19.153-3.697-.167-.04a1.68 1.68 0 0 1 .634-3.282Zm.671 5.988.17.024 17.473 3.361.167.041a1.68 1.68 0 0 1-.802 3.258l-17.472-3.359-.167-.041a1.681 1.681 0 0 1 .631-3.284Zm.295 6.658.17.02 16.129 2.688a1.68 1.68 0 0 1-.552 3.314l-16.129-2.687-.167-.037a1.681 1.681 0 0 1 .549-3.298Zm.39 6.33.17.025 15.12 3.024.167.042a1.68 1.68 0 0 1-.826 3.252l-15.12-3.024-.167-.041a1.68 1.68 0 0 1 .656-3.278Z" />
            </g>
            <g v-else>
              <path
                d="M30.7719 132.969C29.8833 129.582 29.2845 118.12 29.0962 112.811L43.8377 110.896C43.7233 119.732 43.3331 140.81 42.6869 154.436C42.0407 168.063 38.1767 176.643 36.3255 179.23C36.0226 179.767 35.1946 180.318 34.306 178.222C33.1953 175.601 32.6904 165.422 32.5894 158.468C32.4884 151.513 31.8826 137.202 30.7719 132.969Z"
                v-bind:class="{ selected: isSelected('root_1') }"
                v-bind:fill="partColor['root_1'] || '#FFF'"
                v-on:click="onClick('root_1', $event)"
                v-on:keydown="onClick('root_1', $event)" />
              <path
                d="M41.0969 124.603L41.1335 124.616C41.4826 124.737 41.7796 124.975 41.9751 125.288C42.1778 125.614 42.2658 125.993 42.2252 126.375C41.3453 134.627 39.9928 149.45 39.4402 151.736C39.4298 151.78 39.414 151.813 39.391 151.852C39.2498 152.086 38.9046 152.098 38.7812 151.853C38.7551 151.802 38.7388 151.761 38.7399 151.742C39.2388 142.807 38.3786 131.135 37.6453 126.064L37.5721 125.508C37.5389 125.256 37.605 125 37.7563 124.796C37.888 124.618 38.0758 124.49 38.2894 124.432L38.5633 124.358L38.5809 124.357C39.031 124.323 39.483 124.324 39.9331 124.358L40.7051 124.5C40.8382 124.524 40.9691 124.558 41.0969 124.603Z"
                v-bind:class="{ selected: isSelected('central_canal') }"
                v-bind:fill="partColor['central_canal'] || '#FF82BE'"
                v-on:click="onClick('central_canal', $event)"
                v-on:keydown="onClick('central_canal', $event)" />
              <path
                d="M35.7175 129.162L35.8561 129.194C36.1807 129.271 36.4703 129.453 36.6788 129.714C36.9526 130.055 37.0714 130.494 37.0126 130.928C35.6172 141.229 36.2643 154.212 35.9072 156.557C35.8997 156.607 35.8845 156.648 35.8615 156.692C35.7313 156.945 35.3788 156.99 35.22 156.754C35.1836 156.7 35.1595 156.656 35.1588 156.636C34.8362 147.591 33.4454 135.992 32.1769 130.953L32.0498 130.417C31.9877 130.156 32.0351 129.88 32.1811 129.654C32.3002 129.47 32.4773 129.33 32.6844 129.258L32.9938 129.15L33.0116 129.147C33.4897 129.072 33.9725 129.03 34.4564 129.023L35.3003 129.095C35.4408 129.107 35.5802 129.13 35.7175 129.162Z"
                v-bind:class="{ selected: isSelected('additional_canal') }"
                v-bind:fill="partColor['additional_canal'] || '#FF82BE'"
                v-on:click="onClick('additional_canal', $event)"
                v-on:keydown="onClick('additional_canal', $event)" />
            </g>
            <path
              v-if="!isDiagnosisImplant || hasCrownOnImplant"
              d="M43.6961 85.6994L30.3632 85.6037C29.896 85.6003 29.4297 85.6447 28.9716 85.7362C28.758 85.7788 28.5461 85.8349 28.3622 85.9514C27.9919 86.186 27.3411 86.7385 26.8677 87.9083C26.4478 88.9459 26.4192 90.0883 26.4355 91.2075C26.494 95.2189 26.8631 102.458 28.045 108.981C28.307 110.427 28.6687 111.698 29.0957 112.811C30.6427 116.844 33.0461 118.804 34.6646 119.509C35.1495 119.721 35.6832 119.765 36.2121 119.765C37.2178 119.765 38.229 119.569 39.0387 118.972C40.4641 117.922 42.2961 116.014 43.1912 113.214C43.411 112.527 43.6276 111.74 43.8371 110.896C44.7827 107.087 45.2814 102 45.612 99.6079C45.6456 96.7523 45.9983 90.638 45.9175 88.6222C45.872 87.4852 45.5886 86.7437 45.2778 86.2891C44.938 85.7923 44.298 85.6994 43.6961 85.6994Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
          <svg
            v-else-if="isBoneImplant"
            class="tooth-down-2 tooth__parts"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 72 183">
            <g id="implant">
              <rect width="25.564" height="13.231" x="23.762" y="109.08" fill="#A8BEC5" stroke="#778F9F" rx="1.397" />
              <path fill="#778F9F" stroke="#778F9F" stroke-width=".949" d="M46.96 126.171H26.129l4.836 55.777h11.904l4.093-55.777Z" />
              <rect width="29.845" height="4.309" x="-.474" y=".474" fill="#A8BEC5" stroke="#778F9F" stroke-width=".949" rx="1.146" transform="matrix(1 0 0 -1 22.096 127.12)" />
              <path fill="#A8BEC5" stroke="#778F9F" stroke-linecap="round" stroke-width=".949" d="M23.465 130.829a1.68 1.68 0 0 1 1.939-1.372l23.52 4.032.168.037a1.68 1.68 0 0 1-.736 3.274l-23.52-4.032a1.68 1.68 0 0 1-1.371-1.939Zm2.433 5.266.17.02 22.177 3.696a1.68 1.68 0 0 1-.552 3.314l-22.177-3.695-.167-.037a1.681 1.681 0 0 1 .549-3.298Zm.339 6.326.172.02 21.84 3.696a1.68 1.68 0 0 1-.56 3.313l-21.842-3.696-.167-.037a1.68 1.68 0 0 1 .557-3.296Zm-.758 7.729a1.68 1.68 0 0 1 1.929-1.386l20.496 3.359a1.68 1.68 0 1 1-.544 3.316l-20.495-3.36a1.68 1.68 0 0 1-1.386-1.929Zm2.141 4.924.171.024 19.152 3.696a1.68 1.68 0 0 1-.636 3.299l-19.153-3.697-.167-.04a1.68 1.68 0 0 1 .634-3.282Zm.671 5.988.17.024 17.473 3.361.167.041a1.68 1.68 0 0 1-.802 3.258l-17.472-3.359-.167-.041a1.681 1.681 0 0 1 .631-3.284Zm.295 6.658.17.02 16.129 2.688a1.68 1.68 0 0 1-.552 3.314l-16.129-2.687-.167-.037a1.681 1.681 0 0 1 .549-3.298Zm.39 6.33.17.025 15.12 3.024.167.042a1.68 1.68 0 0 1-.826 3.252l-15.12-3.024-.167-.041a1.68 1.68 0 0 1 .656-3.278Z" />
            </g>
            <path
              v-if="hasCrownOnImplant"
              d="M43.6961 85.6994L30.3632 85.6037C29.896 85.6003 29.4297 85.6447 28.9716 85.7362C28.758 85.7788 28.5461 85.8349 28.3622 85.9514C27.9919 86.186 27.3411 86.7385 26.8677 87.9083C26.4478 88.9459 26.4192 90.0883 26.4355 91.2075C26.494 95.2189 26.8631 102.458 28.045 108.981C28.307 110.427 28.6687 111.698 29.0957 112.811C30.6427 116.844 33.0461 118.804 34.6646 119.509C35.1495 119.721 35.6832 119.765 36.2121 119.765C37.2178 119.765 38.229 119.569 39.0387 118.972C40.4641 117.922 42.2961 116.014 43.1912 113.214C43.411 112.527 43.6276 111.74 43.8371 110.896C44.7827 107.087 45.2814 102 45.612 99.6079C45.6456 96.7523 45.9983 90.638 45.9175 88.6222C45.872 87.4852 45.5886 86.7437 45.2778 86.2891C44.938 85.7923 44.298 85.6994 43.6961 85.6994Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
          <button
            class="tooth__body__all-tooth"
            type="button"
            v-on:click="onAllToothClick($event)" />
          <button
            class="tooth__body__gingiva"
            type="button"
            v-bind:class="{ selected: isSelected('gingiva') }"
            v-bind:style="{ 'background-color': partColor['gingiva'] || '#f4ddc1' }"
            v-on:click="onClick('gingiva', $event)" />
          <button
            class="tooth__body__bone"
            type="button"
            v-bind:class="{ selected: isSelected('bone') }"
            v-bind:style="{ 'background-color': partColor['bone'] || '#ffead2' }"
            v-on:click="onClick('bone', $event)" />
        </div>
      </template>
      <form-teeth-formula-diagnoses
        v-bind:class="{ 'disable-component': disabled }"
        v-bind:is-deleted="needDeleted"
        v-bind:part-list="partList"
        v-bind:has-implant="hasImplant"
        v-on:cancel="onCloseMenu"
        v-on:change-diagnoses="onChangeDiagnoses"
        v-on:change-tooth-deleted="onChangeToothDeleted"
        v-on:submit="onSubmit" />
    </tooth-popover-menu>
    <bottom-tooth-surface
      v-bind:surface="surface"
      v-bind:part-selected="partSelected"
      v-bind:selected-parts="selectedParts"
      v-bind:flip="flip"
      v-on:select="onClick" />
    <div class="tooth__number">{{ tooth.number }}</div>
  </div>
</template>
<script>
import toothMixin from '@/mixins/toothMixin';
import ToothPopoverMenu from '../ToothPopoverMenu.vue';
import FormTeethFormulaDiagnoses from '../FormTeethFormulaDiagnoses.vue';
import BottomToothSurface from '../BottomToothSurface.vue';

export default {
  components: {
    ToothPopoverMenu,
    FormTeethFormulaDiagnoses,
    BottomToothSurface,
  },
  mixins: [toothMixin],
  name: 'ToothDown2',
};
</script>

<style scoped>
.tooth {
  flex-direction: column-reverse;
}
.tooth__body {
  grid-template-rows: 30px 25px 66px;
}
.tooth__parts {
  top: auto;
  bottom: 17.28px;
}
</style>
